export const SERVICE_NAMES: Record<string, string> = {
    'primary-database': 'Main Database',
    'redis-cache': 'In-Memory Cache',
    's3-storage': 'File Storage',
    'local-storage': 'Local Storage',
    'application-server': 'API Service',
    'main-api': 'API Service',
    'renderer': 'Post Rendering Service',
    'llm-scraper': 'AI Engine'
};

export const SERVICE_TIERS = {
    CORE: ['primary-database', 'redis-cache', 's3-storage', 'local-storage'],
    PLATFORM: ['application-server', 'main-api', 'api-service'],
    PROCESSING: ['renderer', 'llm-scraper']
};

export const STORAGE_NODES = ['primary-database', 's3-storage', 'local-storage'];
